import * as PIXI from "pixi.js";
import { BitmapTextFieldProperties } from "../../game/control/properties/BitmapTextFieldProperties";
import { TitanBitmapTextField } from "../../game/control/TitanBitmapTextField";
import { TitanText } from "../../game/control/TitanText";
/**
 * ViewUtils.ts
 */
export class ViewUtils {
    /**
     * Creates a new PIXI.Container and optionally adds it to a parent container.
     * @param parent The parent container to add the new container to.
     * @param name The name of the new container.
     * @returns The newly created PIXI.Container.
     */
    static createContainer(parent, name) {
        let container = new PIXI.Container();
        if (name) {
            container.name = name;
        }
        if (parent) {
            parent.addChild(container);
        }
        return container;
    }
    static createField(...args) {
        let _parent, _name, _properties, _portraitProperties;
        if (typeof args[1] === "string") {
            [_parent, _name, _properties, _portraitProperties] = args;
        }
        else {
            [_parent, _properties, _portraitProperties] = args;
            _name = "TextField";
        }
        if (_properties instanceof BitmapTextFieldProperties) {
            return TitanBitmapTextField.createField(_parent, _name, _properties, _portraitProperties);
        }
        else {
            return TitanText.createField(_parent, _name, _properties, _portraitProperties);
        }
    }
}
//# sourceMappingURL=ViewUtils.js.map